module.exports = __webpack_public_path__ + "static/img/top-img2.15111ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/mt_img/top-img2.png
// module id = I+7j
// module chunks = 0